/* eslint-disable */
// @ts-nocheck
// source: internal/job_scope_change.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ApproveJobScopeChangeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ApproveJobScopeChangeResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateJobScopeChangeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateJobScopeChangeResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobScopeChangeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChange', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeResponder', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeChangeStatusAggregations', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeInventoryItemType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeItemType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeResponderType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeUpdateRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobScopeUpdateResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobScopeChangesRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobScopeChangesResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RejectJobScopeChangeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RejectJobScopeChangeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.displayName = 'proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.displayName = 'proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.displayName = 'proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.displayName = 'proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.displayName = 'proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobScopeChange.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChange.displayName = 'proto.worklayer.internal.v1.JobScopeChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeItem.displayName = 'proto.worklayer.internal.v1.JobScopeChangeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeResponder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeResponder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeResponder.displayName = 'proto.worklayer.internal.v1.JobScopeChangeResponder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobScopeUpdateRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeUpdateRequest.displayName = 'proto.worklayer.internal.v1.JobScopeUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.displayName = 'proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.displayName = 'proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.displayName = 'proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeUpdateResponse.displayName = 'proto.worklayer.internal.v1.JobScopeUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.displayName = 'proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.displayName = 'proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.displayName = 'proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.CreateJobScopeChangeRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateJobScopeChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.displayName = 'proto.worklayer.internal.v1.CreateJobScopeChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.displayName = 'proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.CreateJobScopeChangeResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateJobScopeChangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse.displayName = 'proto.worklayer.internal.v1.CreateJobScopeChangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.displayName = 'proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.displayName = 'proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.displayName = 'proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.displayName = 'proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ApproveJobScopeChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.displayName = 'proto.worklayer.internal.v1.ApproveJobScopeChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ApproveJobScopeChangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.displayName = 'proto.worklayer.internal.v1.ApproveJobScopeChangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RejectJobScopeChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RejectJobScopeChangeRequest.displayName = 'proto.worklayer.internal.v1.RejectJobScopeChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RejectJobScopeChangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse.displayName = 'proto.worklayer.internal.v1.RejectJobScopeChangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobScopeChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobScopeChangeRequest.displayName = 'proto.worklayer.internal.v1.GetJobScopeChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.displayName = 'proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeStatusAggregations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.displayName = 'proto.worklayer.internal.v1.JobScopeChangeStatusAggregations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.displayName = 'proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListJobScopeChangesRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobScopeChangesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobScopeChangesRequest.displayName = 'proto.worklayer.internal.v1.ListJobScopeChangesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListJobScopeChangesResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobScopeChangesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobScopeChangesResponse.displayName = 'proto.worklayer.internal.v1.ListJobScopeChangesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.displayName = 'proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.displayName = 'proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.displayName = 'proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.displayName = 'proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    previousScopePrice: (f = msg.getPreviousScopePrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newScopePrice: (f = msg.getNewScopePrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.toObject, includeInstance),
    dateResponded: (f = msg.getDateResponded()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse;
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousScopePrice(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewScopePrice(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateResponded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPreviousScopePrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewScopePrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.serializeBinaryToWriter
    );
  }
  f = message.getDateResponded();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobScopeChangeStatus status = 2;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_scope_price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getPreviousScopePrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setPreviousScopePrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.clearPreviousScopePrice = function() {
  return this.setPreviousScopePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.hasPreviousScopePrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_scope_price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getNewScopePrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setNewScopePrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.clearNewScopePrice = function() {
  return this.setNewScopePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.hasNewScopePrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated JobScopeChangeItemBreakdownForClient items = 5;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient>}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient, 5));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient>} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional google.protobuf.Timestamp date_responded = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.getDateResponded = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.setDateResponded = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.clearDateResponded = function() {
  return this.setDateResponded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.prototype.hasDateResponded = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemVersionId: (f = msg.getInventoryItemVersionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    previousQuantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    newQuantity: jspb.Message.getFieldWithDefault(msg, 5, 0),
    previousPrice: (f = msg.getPreviousPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newPrice: (f = msg.getNewPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient;
  return proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemVersionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPreviousQuantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewQuantity(value);
      break;
    case 6:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousPrice(value);
      break;
    case 7:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemVersionId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPreviousQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNewQuantity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPreviousPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue inventory_item_version_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getInventoryItemVersionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.clearInventoryItemVersionId = function() {
  return this.setInventoryItemVersionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.hasInventoryItemVersionId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 previous_quantity = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getPreviousQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setPreviousQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 new_quantity = 5;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getNewQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setNewQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_price = 6;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getPreviousPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setPreviousPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.clearPreviousPrice = function() {
  return this.setPreviousPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.hasPreviousPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_price = 7;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.getNewPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 7));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.setNewPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.clearNewPrice = function() {
  return this.setNewPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItemBreakdownForClient.prototype.hasNewPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest;
  return proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    previousScopePrice: (f = msg.getPreviousScopePrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newScopePrice: (f = msg.getNewScopePrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    previousScopeProPrice: (f = msg.getPreviousScopeProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newScopeProPrice: (f = msg.getNewScopeProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    previousTotalPrice: (f = msg.getPreviousTotalPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newTotalPrice: (f = msg.getNewTotalPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    previousTotalProPrice: (f = msg.getPreviousTotalProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newTotalProPrice: (f = msg.getNewTotalProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse;
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousScopePrice(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewScopePrice(value);
      break;
    case 5:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousScopeProPrice(value);
      break;
    case 6:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewScopeProPrice(value);
      break;
    case 7:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousTotalPrice(value);
      break;
    case 8:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewTotalPrice(value);
      break;
    case 9:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousTotalProPrice(value);
      break;
    case 10:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewTotalProPrice(value);
      break;
    case 11:
      var value = new proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPreviousScopePrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewScopePrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPreviousScopeProPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewScopeProPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPreviousTotalPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewTotalPrice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPreviousTotalProPrice();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewTotalProPrice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemVersionId: (f = msg.getInventoryItemVersionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    previousQuantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    newQuantity: jspb.Message.getFieldWithDefault(msg, 5, 0),
    previousPrice: (f = msg.getPreviousPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newPrice: (f = msg.getNewPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    previousProPrice: (f = msg.getPreviousProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    newProPrice: (f = msg.getNewProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    bundleId: (f = msg.getBundleId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin;
  return proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemVersionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPreviousQuantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewQuantity(value);
      break;
    case 6:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousPrice(value);
      break;
    case 7:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewPrice(value);
      break;
    case 8:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPreviousProPrice(value);
      break;
    case 9:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setNewProPrice(value);
      break;
    case 10:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBundleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemVersionId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPreviousQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNewQuantity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPreviousPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPreviousProPrice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getNewProPrice();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getBundleId();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType = {
  FLAT: 0,
  FEE: 1,
  MARKUP: 2,
  MARKDOWN: 3,
  CUSTOM: 4
};

/**
 * optional google.protobuf.StringValue inventory_item_version_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getInventoryItemVersionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearInventoryItemVersionId = function() {
  return this.setInventoryItemVersionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasInventoryItemVersionId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 previous_quantity = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getPreviousQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setPreviousQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 new_quantity = 5;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getNewQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setNewQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_price = 6;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getPreviousPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setPreviousPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearPreviousPrice = function() {
  return this.setPreviousPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasPreviousPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_price = 7;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getNewPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 7));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setNewPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearNewPrice = function() {
  return this.setNewPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasNewPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_pro_price = 8;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getPreviousProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 8));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setPreviousProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearPreviousProPrice = function() {
  return this.setPreviousProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasPreviousProPrice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_pro_price = 9;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getNewProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 9));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setNewProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearNewProPrice = function() {
  return this.setNewProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasNewProPrice = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional JobScopeChangeItemPriceType price_type = 10;
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getPriceType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.JobScopeChangeItemPriceType} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional google.protobuf.StringValue bundle_id = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.getBundleId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.setBundleId = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.clearBundleId = function() {
  return this.setBundleId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin.prototype.hasBundleId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobScopeChangeStatus status = 2;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_scope_price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getPreviousScopePrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setPreviousScopePrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearPreviousScopePrice = function() {
  return this.setPreviousScopePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasPreviousScopePrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_scope_price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getNewScopePrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setNewScopePrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearNewScopePrice = function() {
  return this.setNewScopePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasNewScopePrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_scope_pro_price = 5;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getPreviousScopeProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setPreviousScopeProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearPreviousScopeProPrice = function() {
  return this.setPreviousScopeProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasPreviousScopeProPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_scope_pro_price = 6;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getNewScopeProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setNewScopeProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearNewScopeProPrice = function() {
  return this.setNewScopeProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasNewScopeProPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_total_price = 7;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getPreviousTotalPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 7));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setPreviousTotalPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearPreviousTotalPrice = function() {
  return this.setPreviousTotalPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasPreviousTotalPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_total_price = 8;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getNewTotalPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 8));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setNewTotalPrice = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearNewTotalPrice = function() {
  return this.setNewTotalPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasNewTotalPrice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal previous_total_pro_price = 9;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getPreviousTotalProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 9));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setPreviousTotalProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearPreviousTotalProPrice = function() {
  return this.setPreviousTotalProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasPreviousTotalProPrice = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal new_total_pro_price = 10;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getNewTotalProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 10));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setNewTotalProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearNewTotalProPrice = function() {
  return this.setNewTotalProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.hasNewTotalProPrice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated JobScopeChangeItemBreakdownForAdmin items = 11;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin>}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin, 11));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin>} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
*/
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin}
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.JobScopeChangeItemBreakdownForAdmin, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobScopeChange.repeatedFields_ = [11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    createdByUserPublicId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    pricedByUserPublicId: (f = msg.getPricedByUserPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    requireClientApproval: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    reason: jspb.Message.getFieldWithDefault(msg, 8, ""),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    priceTime: (f = msg.getPriceTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.JobScopeChangeItem.toObject, includeInstance),
    respondersList: jspb.Message.toObjectList(msg.getRespondersList(),
    proto.worklayer.internal.v1.JobScopeChangeResponder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChange}
 */
proto.worklayer.internal.v1.JobScopeChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChange;
  return proto.worklayer.internal.v1.JobScopeChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChange}
 */
proto.worklayer.internal.v1.JobScopeChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserPublicId(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPricedByUserPublicId(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequireClientApproval(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPriceTime(value);
      break;
    case 11:
      var value = new proto.worklayer.internal.v1.JobScopeChangeItem;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 12:
      var value = new proto.worklayer.internal.v1.JobScopeChangeResponder;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeResponder.deserializeBinaryFromReader);
      msg.addResponders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCreatedByUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPricedByUserPublicId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRequireClientApproval();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPriceTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.worklayer.internal.v1.JobScopeChangeItem.serializeBinaryToWriter
    );
  }
  f = message.getRespondersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.worklayer.internal.v1.JobScopeChangeResponder.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobScopeChangeStatus status = 4;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string created_by_user_public_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getCreatedByUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setCreatedByUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue priced_by_user_public_id = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getPricedByUserPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
*/
proto.worklayer.internal.v1.JobScopeChange.prototype.setPricedByUserPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.clearPricedByUserPublicId = function() {
  return this.setPricedByUserPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.hasPricedByUserPublicId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool require_client_approval = 7;
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getRequireClientApproval = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setRequireClientApproval = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string reason = 8;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp create_time = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
*/
proto.worklayer.internal.v1.JobScopeChange.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp price_time = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getPriceTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
*/
proto.worklayer.internal.v1.JobScopeChange.prototype.setPriceTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.clearPriceTime = function() {
  return this.setPriceTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.hasPriceTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated JobScopeChangeItem items = 11;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeItem, 11));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
*/
proto.worklayer.internal.v1.JobScopeChange.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.worklayer.internal.v1.JobScopeChangeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated JobScopeChangeResponder responders = 12;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeResponder>}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.getRespondersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeResponder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeResponder, 12));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeResponder>} value
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
*/
proto.worklayer.internal.v1.JobScopeChange.prototype.setRespondersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeResponder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder}
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.addResponders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.worklayer.internal.v1.JobScopeChangeResponder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeChange} returns this
 */
proto.worklayer.internal.v1.JobScopeChange.prototype.clearRespondersList = function() {
  return this.setRespondersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    inventoryItemVersionId: (f = msg.getInventoryItemVersionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeItem;
  return proto.worklayer.internal.v1.JobScopeChangeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeItemType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 6:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItemVersionId();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional JobScopeItemType type = 4;
 * @return {!proto.worklayer.internal.v1.JobScopeItemType}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeItemType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeItemType} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 5;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 6;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue inventory_item_version_id = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.getInventoryItemVersionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.clearInventoryItemVersionId = function() {
  return this.setInventoryItemVersionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeItem.prototype.hasInventoryItemVersionId = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeResponder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeResponder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    responderUserPublicId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responderType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    responseType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    reason: (f = msg.getReason()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeResponder;
  return proto.worklayer.internal.v1.JobScopeChangeResponder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeResponder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponderUserPublicId(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeResponderType} */ (reader.readEnum());
      msg.setResponderType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseType(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeResponder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeResponder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponderUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponderType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getResponseType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReason();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string responder_user_public_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getResponderUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setResponderUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional JobScopeResponderType responder_type = 3;
 * @return {!proto.worklayer.internal.v1.JobScopeResponderType}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getResponderType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeResponderType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeResponderType} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setResponderType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string response_type = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getResponseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp create_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue reason = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.getReason = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.setReason = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeResponder} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.clearReason = function() {
  return this.setReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeResponder.prototype.hasReason = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.repeatedFields_ = [3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
    customItemsToAddList: jspb.Message.toObjectList(msg.getCustomItemsToAddList(),
    proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.toObject, includeInstance),
    customItemsToRemoveList: jspb.Message.toObjectList(msg.getCustomItemsToRemoveList(),
    proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.toObject, includeInstance),
    inventoryItemsList: jspb.Message.toObjectList(msg.getInventoryItemsList(),
    proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeUpdateRequest;
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.deserializeBinaryFromReader);
      msg.addCustomItemsToAdd(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.deserializeBinaryFromReader);
      msg.addCustomItemsToRemove(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.deserializeBinaryFromReader);
      msg.addInventoryItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomItemsToAddList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.serializeBinaryToWriter
    );
  }
  f = message.getCustomItemsToRemoveList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem;
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
*/
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
*/
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem;
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem;
  return proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated JobScopeUpdateCreateCustomItem custom_items_to_add = 3;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem>}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.getCustomItemsToAddList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem>} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
*/
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.setCustomItemsToAddList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.addCustomItemsToAdd = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateCreateCustomItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.clearCustomItemsToAddList = function() {
  return this.setCustomItemsToAddList([]);
};


/**
 * repeated JobScopeUpdateRemoveCustomItem custom_items_to_remove = 4;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem>}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.getCustomItemsToRemoveList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem>} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
*/
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.setCustomItemsToRemoveList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.addCustomItemsToRemove = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateRemoveCustomItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.clearCustomItemsToRemoveList = function() {
  return this.setCustomItemsToRemoveList([]);
};


/**
 * repeated JobScopeUpdateInventoryItem inventory_items = 5;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem>}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.getInventoryItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem, 5));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem>} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
*/
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.setInventoryItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem}
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.addInventoryItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.worklayer.internal.v1.JobScopeUpdateRequest.JobScopeUpdateInventoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateRequest} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateRequest.prototype.clearInventoryItemsList = function() {
  return this.setInventoryItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateResponse}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeUpdateResponse;
  return proto.worklayer.internal.v1.JobScopeUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateResponse}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeUpdateResponse} returns this
 */
proto.worklayer.internal.v1.JobScopeUpdateResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobScopeChangeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newCustomScopeItemsList: jspb.Message.toObjectList(msg.getNewCustomScopeItemsList(),
    proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.toObject, includeInstance),
    newInventoryScopeItemsList: jspb.Message.toObjectList(msg.getNewInventoryScopeItemsList(),
    proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest;
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobScopeChangeId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest;
      reader.readMessage(value,proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.deserializeBinaryFromReader);
      msg.addNewCustomScopeItems(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest;
      reader.readMessage(value,proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader);
      msg.addNewInventoryScopeItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobScopeChangeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewCustomScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.serializeBinaryToWriter
    );
  }
  f = message.getNewInventoryScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest;
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest;
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
*/
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
*/
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string job_scope_change_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.getJobScopeChangeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.setJobScopeChangeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NewJobScopeChangeCustomItemRequest new_custom_scope_items = 2;
 * @return {!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest>}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.getNewCustomScopeItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest>} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} returns this
*/
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.setNewCustomScopeItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.addNewCustomScopeItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeCustomItemRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.clearNewCustomScopeItemsList = function() {
  return this.setNewCustomScopeItemsList([]);
};


/**
 * repeated NewJobScopeChangeInventoryItemRequest new_inventory_scope_items = 3;
 * @return {!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest>}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.getNewInventoryScopeItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest>} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} returns this
*/
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.setNewInventoryScopeItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.addNewInventoryScopeItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.NewJobScopeChangeInventoryItemRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest.prototype.clearNewInventoryScopeItemsList = function() {
  return this.setNewInventoryScopeItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse;
  return proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse} returns this
 */
proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.toObject, includeInstance),
    inventoryItemsList: jspb.Message.toObjectList(msg.getInventoryItemsList(),
    proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateJobScopeChangeRequest;
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest;
      reader.readMessage(value,proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest;
      reader.readMessage(value,proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader);
      msg.addInventoryItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest;
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest;
  return proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CreateJobScopeChangeItemRequest items = 3;
 * @return {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest>}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest>} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeItemRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated CreateJobScopeChangeInventoryItemRequest inventory_items = 4;
 * @return {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest>}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.getInventoryItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest>} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.setInventoryItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.addInventoryItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.v1.CreateJobScopeChangeRequest.CreateJobScopeChangeInventoryItemRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeRequest.prototype.clearInventoryItemsList = function() {
  return this.setInventoryItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateJobScopeChangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateJobScopeChangeResponse;
  return proto.worklayer.internal.v1.CreateJobScopeChangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse;
      reader.readMessage(value,proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    inventoryItemVersionId: (f = msg.getInventoryItemVersionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse;
  return proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemVersionId(value);
      break;
    case 5:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 6:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getInventoryItemVersionId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue inventory_item_version_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getInventoryItemVersionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.clearInventoryItemVersionId = function() {
  return this.setInventoryItemVersionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.hasInventoryItemVersionId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 5;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 6;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 6));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional JobScopeChangeStatus status = 3;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated CreateJobScopeChangeItemResponse items = 4;
 * @return {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse>}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse>} value
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} returns this
*/
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse}
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.v1.CreateJobScopeChangeResponse.CreateJobScopeChangeItemResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.CreateJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.CreateJobScopeChangeResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest;
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem;
      reader.readMessage(value,proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem;
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated FinalizeJobScopeChangeItem items = 2;
 * @return {!Array<!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem>}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem>} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.FinalizeJobScopeChangeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pricedByUserPublicId: (f = msg.getPricedByUserPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    priceTime: (f = msg.getPriceTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.JobScopeChangeItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse;
  return proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPricedByUserPublicId(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPriceTime(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.JobScopeChangeItem;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPricedByUserPublicId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPriceTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.worklayer.internal.v1.JobScopeChangeItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional JobScopeChangeStatus status = 3;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue priced_by_user_public_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getPricedByUserPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setPricedByUserPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.clearPricedByUserPublicId = function() {
  return this.setPricedByUserPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.hasPricedByUserPublicId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp price_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getPriceTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setPriceTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.clearPriceTime = function() {
  return this.setPriceTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.hasPriceTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated JobScopeChangeItem items = 6;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeItem, 6));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeItem>} value
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
*/
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeItem}
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.worklayer.internal.v1.JobScopeChangeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    skipClientApproval: (f = msg.getSkipClientApproval()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ApproveJobScopeChangeRequest;
  return proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSkipClientApproval(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSkipClientApproval();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue skip_client_approval = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.getSkipClientApproval = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} returns this
*/
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.setSkipClientApproval = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.clearSkipClientApproval = function() {
  return this.setSkipClientApproval(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeRequest.prototype.hasSkipClientApproval = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ApproveJobScopeChangeResponse;
  return proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobScopeChangeStatus status = 2;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RejectJobScopeChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RejectJobScopeChangeRequest;
  return proto.worklayer.internal.v1.RejectJobScopeChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RejectJobScopeChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.RejectJobScopeChangeRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RejectJobScopeChangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RejectJobScopeChangeResponse;
  return proto.worklayer.internal.v1.RejectJobScopeChangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobScopeChangeStatus status = 2;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.RejectJobScopeChangeResponse} returns this
 */
proto.worklayer.internal.v1.RejectJobScopeChangeResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobScopeChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobScopeChangeRequest;
  return proto.worklayer.internal.v1.GetJobScopeChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobScopeChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest;
  return proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addWorkspaceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string workspace_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeStatusAggregations;
  return proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional JobScopeChangeStatus status = 1;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobScopeChangeStatusAggregationList: jspb.Message.toObjectList(msg.getJobScopeChangeStatusAggregationList(),
    proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse;
  return proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobScopeChangeStatusAggregations;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.deserializeBinaryFromReader);
      msg.addJobScopeChangeStatusAggregation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobScopeChangeStatusAggregationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobScopeChangeStatusAggregations.serializeBinaryToWriter
    );
  }
};


/**
 * repeated JobScopeChangeStatusAggregations job_scope_change_status_aggregation = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations>}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.getJobScopeChangeStatusAggregationList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeStatusAggregations, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations>} value
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse} returns this
*/
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.setJobScopeChangeStatusAggregationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatusAggregations}
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.addJobScopeChangeStatusAggregation = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobScopeChangeStatusAggregations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse} returns this
 */
proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.prototype.clearJobScopeChangeStatusAggregationList = function() {
  return this.setJobScopeChangeStatusAggregationList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobScopeChangesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    filter: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobScopeChangesRequest;
  return proto.worklayer.internal.v1.ListJobScopeChangesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addWorkspaceIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobScopeChangesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated string workspace_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};


/**
 * optional string filter = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_by = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobScopeChangesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobScopeChangesList: jspb.Message.toObjectList(msg.getJobScopeChangesList(),
    proto.worklayer.internal.v1.JobScopeChange.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesResponse}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobScopeChangesResponse;
  return proto.worklayer.internal.v1.ListJobScopeChangesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesResponse}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobScopeChange;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChange.deserializeBinaryFromReader);
      msg.addJobScopeChanges(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobScopeChangesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobScopeChangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobScopeChange.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated JobScopeChange job_scope_changes = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChange>}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.getJobScopeChangesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChange>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChange, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChange>} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} returns this
*/
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.setJobScopeChangesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChange}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.addJobScopeChanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobScopeChange, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.clearJobScopeChangesList = function() {
  return this.setJobScopeChangesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesResponse} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest;
  return proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobScopeChangesList: jspb.Message.toObjectList(msg.getJobScopeChangesList(),
    proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse;
  return proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.deserializeBinaryFromReader);
      msg.addJobScopeChanges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobScopeChangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.serializeBinaryToWriter
    );
  }
};


/**
 * repeated JobScopeChangeRequestForCollaborator job_scope_changes = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator>}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.getJobScopeChangesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator>} value
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse} returns this
*/
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.setJobScopeChangesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator}
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.addJobScopeChanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse} returns this
 */
proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.prototype.clearJobScopeChangesList = function() {
  return this.setJobScopeChangesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    createdByUserPublicId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.toObject, includeInstance),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    rejectionReason: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator;
  return proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserPublicId(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCreatedByUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobScopeChangeStatus status = 4;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string created_by_user_public_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getCreatedByUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setCreatedByUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated JobScopeChangeRequestItemForCollaborator items = 6;
 * @return {!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator>}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator, 6));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator>} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional google.protobuf.Timestamp create_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string rejection_reason = 8;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestForCollaborator.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    inventoryItemId: (f = msg.getInventoryItemId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    inventoryItemVersionId: (f = msg.getInventoryItemVersionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    inventoryItemType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator;
  return proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInventoryItemVersionId(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeInventoryItemType} */ (reader.readEnum());
      msg.setInventoryItemType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getInventoryItemId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItemVersionId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItemType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue inventory_item_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getInventoryItemId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setInventoryItemId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.clearInventoryItemId = function() {
  return this.setInventoryItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.hasInventoryItemId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue inventory_item_version_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getInventoryItemVersionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
*/
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.clearInventoryItemVersionId = function() {
  return this.setInventoryItemVersionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.hasInventoryItemVersionId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional JobScopeInventoryItemType inventory_item_type = 6;
 * @return {!proto.worklayer.internal.v1.JobScopeInventoryItemType}
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.getInventoryItemType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeInventoryItemType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeInventoryItemType} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeRequestItemForCollaborator.prototype.setInventoryItemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent;
  return proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent;
  return proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobScopeChangeStatus = {
  PENDING_FINALIZATION: 0,
  PENDING_ADMIN_APPROVAL: 1,
  PENDING_CLIENT_APPROVAL: 2,
  ACCEPTED: 3,
  REJECTED: 4,
  UNSPECIFIED: 5,
  APPLY_FAILED: 6
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobScopeResponderType = {
  CLIENT: 0,
  ADMIN: 1,
  SYSTEM: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobScopeItemType = {
  INVENTORY: 0,
  CUSTOM: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobScopeInventoryItemType = {
  JOB_SCOPE_INVENTORY_ITEM_TYPE_UNSPECIFIED: 0,
  DEFAULT: 1,
  BOOKKEEPING: 2,
  CONSULTATION: 3,
  TAX: 4,
  EXTENSION: 5
};

goog.object.extend(exports, proto.worklayer.internal.v1);
